import { v4 } from 'uuid';

import { privateApi } from '@shared/config/axios.config';

import { Review } from '../model/types';

interface GetModuleReviewsParams {
  moduleId: string;
}

interface ReviewDTO {
  module_id: string;
  rating: number;
  comment: string;
  account_name: string | null;
}

export const getModuleReviewsApi = (params: GetModuleReviewsParams) => {
  return privateApi.get<ReviewDTO[] | null>(`/account/rating/${params.moduleId}`).then(
    ({ data }) =>
      data?.map(
        (dto) =>
          ({
            id: v4(),
            moduleId: dto.module_id,
            rating: dto.rating,
            comment: dto.comment,
            name: dto.account_name || '',
          }) as Review,
      ) || [],
  );
};
